var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _circle3, _circle4, _circle5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 164,
    viewBox: "0 0 200 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 100.083,
    cy: 95.6666,
    r: 68.3333,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 100.084,
    cy: 95.6667,
    r: 51.25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.198 62.8965C110.259 62.8965 118.95 66.4962 125.357 72.9037C131.765 79.3112 135.365 88.0016 135.365 97.0632C135.365 106.125 131.765 114.815 125.357 121.223C118.95 127.63 110.259 131.23 101.198 131.23C92.1364 131.23 83.4459 127.63 77.0384 121.223C70.6309 114.815 67.0312 106.125 67.0312 97.0632C67.0312 88.0016 70.6309 79.3112 77.0384 72.9037C83.4459 66.4962 92.1364 62.8965 101.198 62.8965ZM96.9417 103.804L89.3518 96.209C89.0798 95.9369 88.7567 95.7211 88.4012 95.5738C88.0457 95.4265 87.6647 95.3507 87.2799 95.3507C86.8951 95.3507 86.514 95.4265 86.1585 95.5738C85.803 95.7211 85.48 95.9369 85.2079 96.209C84.6584 96.7585 84.3497 97.5038 84.3497 98.2809C84.3497 99.0581 84.6584 99.8034 85.2079 100.353L94.8722 110.017C95.1435 110.291 95.4663 110.508 95.8219 110.656C96.1775 110.804 96.5589 110.88 96.9442 110.88C97.3294 110.88 97.7108 110.804 98.0664 110.656C98.422 110.508 98.7448 110.291 99.0161 110.017L119.028 90.0004C119.304 89.7294 119.523 89.4066 119.673 89.0504C119.824 88.6942 119.902 88.3118 119.904 87.9253C119.906 87.5387 119.831 87.1556 119.684 86.798C119.537 86.4405 119.321 86.1156 119.047 85.842C118.774 85.5685 118.45 85.3518 118.092 85.2044C117.735 85.057 117.352 84.9817 116.965 84.9831C116.579 84.9844 116.196 85.0623 115.84 85.2122C115.483 85.3621 115.16 85.5811 114.889 85.8565L96.9417 103.804Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.193 115.028L198.027 108.194",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.027 115.028L191.194 108.194",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06987 63.9982L6.15078 53.7791",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 58.9149L11.2193 58.8621",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.492,
    cy: 9.2234,
    r: 4.16774,
    stroke: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.847,
    cy: 155.458,
    r: 2.84722,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.2482,
    cy: 135.252,
    r: 2.89472,
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.127 1.9043C83.303 1.5716 83.7605 1.55057 83.9717 1.8418L84.0107 1.9043L87.7744 9.0166C87.9503 9.34942 87.7094 9.74972 87.333 9.75H79.8047C79.4515 9.75 79.2167 9.39752 79.334 9.0791L79.3623 9.0166L83.127 1.9043Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessicon);
export default __webpack_public_path__ + "static/media/successicon.a92992cf32f9459838c1b68b021d902e.svg";
export { ForwardRef as ReactComponent };